import type { TranslationFunction } from 'global';
import { CurrencySymbols } from 'types/enums';

export const getPeriods = (translate: TranslationFunction): { name: string; value: number }[] => [
  { name: translate('threeDays'), value: 3 },
  { name: translate('week'), value: 7 },
  { name: translate('Month'), value: 30 },
];

export const getCurrencySymbol = (currency: CurrencySymbols) => {
  const currencySymbols: Record<CurrencySymbols, string> = {
    [CurrencySymbols.USD]: '$',
  };

  if (!currencySymbols[currency]) {
    throw new Error('Currency symbol not found: ' + currency);
  }

  return currencySymbols[currency];
};

getCurrencySymbol(CurrencySymbols.USD);
